import authService from '../components/api-authorization/AuthorizeService'
import authorizedFetch from './authorizedFetch';

const BASE_URL = '/api/users';

export const deleteUser = async (userId) => {
    const token = await authService.getAccessToken();
    const response = await fetch(`${BASE_URL}/${userId}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    if (!response.ok) {
        throw new Error(`Failed to delete user with ID: ${userId}`);
    }

    return await response.json();
}

export const deleteUsers = async (userIds) => {
    const response = await authorizedFetch(`${BASE_URL}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userIds),
    });

    if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(text || "Failed to delete users");
    }

    return;
};


export const getUserById = async (userId) => {
    const response = await authorizedFetch(`${BASE_URL}/${userId}`, {
        method: 'GET'
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch user with ID: ${userId}`);
    }
    return await response.json();
}

export const updateUser = async (id, payload) => {
    const response = await authorizedFetch(`${BASE_URL}/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });

    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Failed to update user.");
    }

    return await response.json();
};

export const createUser = async (payload) => {
    const response = await authorizedFetch(`${BASE_URL}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Failed to create user.");
    }

    return await response.json();
};

export const sendEmailConfirmation = async (userId) => {
    const response = await authorizedFetch(`${BASE_URL}/${userId}/send-email-confirmation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" }
    });

    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Failed to send email confirmation.");
    }
};

export const resetPassword = async (userId) => {
    const response = await authorizedFetch(`${BASE_URL}/${userId}/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" }
    });

    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Failed to reset password.");
    }
};

export const validateInvitation = async (userId, token) => {
    const response = await authorizedFetch(
        `${BASE_URL}/validate-invitation?userId=${encodeURIComponent(userId)}&token=${encodeURIComponent(token)}`,
        { method: "GET" }
    );

    if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(text || "Failed to validate invitation.");
    }

    const text = await response.text();
    return text.replace(/^"+|"+$/g, "");
};

export const completeInvitation = async (payload) => {
    const response = await authorizedFetch(`${BASE_URL}/complete-invitation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(text || "Failed to complete invitation.");
    }
};

export const resendInvitation = async (payload) => {
    const response = await authorizedFetch(`${BASE_URL}/resend-invitation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(text || "Failed to resend invitation.");
    }
};

export const validatePasswordReset = async (userId, token) => {
    const response = await authorizedFetch(
        `${BASE_URL}/validate-password-reset?userId=${encodeURIComponent(userId)}&token=${encodeURIComponent(token)}`,
        { method: "GET" }
    );

    if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(text || "Failed to validate password reset.");
    }

    const text = await response.text();
    return text.replace(/^"+|"+$/g, "");
};

export const completePasswordReset = async (payload) => {
    const response = await authorizedFetch(`${BASE_URL}/complete-password-reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(text || "Failed to complete password reset.");
    }
};
